import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'bootstrap/dist/css/bootstrap.css';

import Firebase, { FirebaseContext } from './components/firebase';
import App from './App';

ReactDOM.render(
  <FirebaseContext.Provider value={new Firebase()}>
      <App />
  </FirebaseContext.Provider>,
  document.getElementById('root'),
);

// ReactDOM.render(<Router />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
